module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/narrow-client-display/narrow-client-display.component.scss
// module id = ./src/app/modules/common-module/components/narrow-client-display/narrow-client-display.component.scss
// module chunks = 9